import { FormType } from '../../../../form-types';
import { HemorrhoidFieldAnswers } from '../questions';

export const hemorrhoid: FormType<HemorrhoidFieldAnswers> = {
  name: 'Hemorrhoid Consultation',
  questions: [
    {
      key: 'hemorrhoid_sex',
      next: {
        condition: {
          'hemorrhoid_sex.male': true
        },
        key: 'hemorrhoid_height',
        els: 'hemorrhoid_pregnant'
      }
    },
    {
      key: 'hemorrhoid_pregnant',
      next: {
        condition: {
          'hemorrhoid_pregnant.no': true
        },
        key: 'hemorrhoid_pregnancyConsent',
        els: 'hemorrhoid_trimester'
      }
    },
    'hemorrhoid_trimester',
    {
      key: 'hemorrhoid_pregnancyConsent',
      next: {
        condition: {
          'hemorrhoid_pregnancyConsent.consent': true
        },
        key: 'hemorrhoid_height',
        els: 'hemorrhoid_nonConsent'
      }
    },
    'hemorrhoid_height',
    'hemorrhoid_weight',
    'hemorrhoid_migranesThatWorsenWithNitrate',
    'hemorrhoid_reactionToNitroglycerinCream',
    'hemorrhoid_allergyToDiltiazem',
    {
      key: 'hemorrhoid_historyOfCancer',
      next: {
        condition: {
          'hemorrhoid_historyOfCancer.yes': true
        },
        key: 'hemorrhoid_previousCancerDiagnosis',
        els: 'hemorrhoid_familyCancerHistory'
      }
    },
    'hemorrhoid_previousCancerDiagnosis',
    'hemorrhoid_treatedForCancer',
    'hemorrhoid_ostomy',
    'hemorrhoid_lars',
    'hemorrhoid_residualSymptoms',
    {
      key: 'hemorrhoid_familyCancerHistory',
      next: {
        condition: {
          'hemorrhoid_familyCancerHistory.yes': true
        },
        key: 'hemorrhoid_moreAboutFamilyCancerHistory',
        els: 'hemorrhoid_routingBasedOnSymptoms'
      }
    },
    'hemorrhoid_moreAboutFamilyCancerHistory',
    {
      key: 'hemorrhoid_routingBasedOnSymptoms',
      next: {
        switch: [
          {
            condition: {
              'hemorrhoid_routingBasedOnSymptoms.pain': true
            },
            key: 'hemorrhoid_pain_painLevel'
          },
          {
            condition: {
              'hemorrhoid_routingBasedOnSymptoms.bleeding': true
            },
            key: 'hemorrhoid_bleeding_redBloodDuringBowelMovement'
          },
          {
            condition: {
              'hemorrhoid_routingBasedOnSymptoms.swelling': true
            },
            key: 'hemorrhoid_swelling_symptom'
          }
        ],
        els: 'hemorrhoid_frequencyOfBowelMovements'
      }
    },

    // Pain pathway
    {
      key: 'hemorrhoid_pain_painLevel',
      next: {
        condition: {
          'hemorrhoid_pain_painLevel.other': true
        },
        key: 'hemorrhoid_pain_moreAboutPainLevel',
        els: 'hemorrhoid_pain_painLocation'
      }
    },

    'hemorrhoid_pain_moreAboutPainLevel',
    'hemorrhoid_pain_painLocation',
    'hemorrhoid_pain_painTime',
    'hemorrhoid_pain_lengthOfPainEpisode',

    {
      key: 'hemorrhoid_pain_painRelief',
      next: {
        condition: {
          'hemorrhoid_pain_painRelief.somethingElse': true
        },
        key: 'hemorrhoid_pain_moreAboutPainRelief',
        els: 'hemorrhoid_pain_treatementWithOTC'
      }
    },

    'hemorrhoid_pain_moreAboutPainRelief',

    {
      key: 'hemorrhoid_pain_treatementWithOTC',
      next: {
        condition: {
          'hemorrhoid_pain_treatementWithOTC.other': true
        },
        key: 'hemorrhoid_pain_moreAboutOTC',
        els: 'hemorrhoid_pain_bowelMoveMent'
      }
    },

    'hemorrhoid_pain_moreAboutOTC',
    {
      key: 'hemorrhoid_pain_bowelMoveMent',
      next: {
        switch: [
          {
            condition: {
              'hemorrhoid_routingBasedOnSymptoms.bleeding': true
            },
            key: 'hemorrhoid_bleeding_redBloodDuringBowelMovement'
          },
          {
            condition: {
              'hemorrhoid_routingBasedOnSymptoms.swelling': true
            },
            key: 'hemorrhoid_swelling_symptom'
          }
        ],
        els: 'hemorrhoid_frequencyOfBowelMovements'
      }
    },
    // Bleeding pathway
    {
      key: 'hemorrhoid_bleeding_redBloodDuringBowelMovement',
      next: {
        condition: {
          'hemorrhoid_bleeding_redBloodDuringBowelMovement.yes': true
        },
        key: 'hemorrhoid_bleeding_locationOfBlood',
        els: 'hemorrhoid_bleeding_bleedingRecurrence'
      }
    },

    'hemorrhoid_bleeding_locationOfBlood',
    'hemorrhoid_bleeding_bleedingRecurrence',
    'hemorrhoid_bleeding_lengthOfEpisode',
    'hemorrhoid_bleeding_bleedingType',

    {
      key: 'hemorrhoid_bleeding_darkStool',
      next: {
        switch: [
          {
            condition: {
              'hemorrhoid_bleeding_darkStool.yes': true
            },
            key: 'hemorrhoid_ineligible'
          },
          {
            condition: {
              'hemorrhoid_routingBasedOnSymptoms.swelling': true
            },
            key: 'hemorrhoid_swelling_symptom'
          }
        ],
        els: 'hemorrhoid_frequencyOfBowelMovements'
      }
    },

    // Swelling pathway
    'hemorrhoid_swelling_symptom',
    'hemorrhoid_swelling_triggers',
    'hemorrhoid_swelling_receptiveIntercourse',

    {
      key: 'hemorrhoid_swelling_STI',
      next: {
        condition: {
          'hemorrhoid_swelling_STI.yes': true
        },
        key: 'hemorrhoid_swelling_inPersonConfirmation',
        els: 'hemorrhoid_frequencyOfBowelMovements'
      }
    },

    {
      key: 'hemorrhoid_swelling_inPersonConfirmation',
      next: {
        condition: {
          'hemorrhoid_swelling_inPersonConfirmation.notSeekCare': true
        },
        key: 'hemorrhoid_ineligible',
        els: 'hemorrhoid_frequencyOfBowelMovements'
      }
    },

    'hemorrhoid_frequencyOfBowelMovements',

    'hemorrhoid_otherIssues',
    'hemorrhoid_strain',
    'hemorrhoid_stoolExam',
    'hemorrhoid_supplements',
    'hemorrhoid_otherInformation',

    {
      key: 'hemorrhoid_truthfulnessConsent',
      next: {
        condition: {
          'hemorrhoid_truthfulnessConsent.consent': true
        },
        key: 'hemorrhoid_consent',
        els: 'hemorrhoid_nonConsent'
      }
    },
    {
      key: 'hemorrhoid_consent',
      next: {
        condition: {
          'hemorrhoid_consent.consent': true
        },
        key: 'hemorrhoid_complete',
        els: 'hemorrhoid_nonConsent'
      }
    },

    'hemorrhoid_nonConsent',
    'hemorrhoid_ineligible',
    'hemorrhoid_complete'
  ]
};
